export default __webpack_public_path__ + "static/protection-d5f7678833bb35c2f01b221dd24ea7d6.svg";